import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { TelemedStateActionService } from '../statemanagement/telemed-state-action.service';

@Component({
    selector: 'app-daz-form-fail',
    templateUrl: './daz-form-fail.component.html',
    styleUrls: ['./daz-form-fail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DazFormFailComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private lineStateAction: LineStateActionService,
    private router: Router,
    private telemedStateActionService: TelemedStateActionService,
    private lineActionService: LineStateActionService,
  ) { }
  headers = signal<any>(["สมัครใช้บริการปรึกษาแพทย์ออนไลน์ไม่สำเร็จ"]);
  body = ""
  btnOk = signal<string>("คลิก");
  btnCancel = "ยกเลิก";
  isShowButton = false;
  code = "";
  comcode = "insure";
  error_template = {
    "E500": "ขออภัยในความไม่สะดวก ระบบเกิดข้อผิดพลาด กรุณาแจ้งแอดมินเพื่ออำนวยความสะดวกให้ท่านต่อไป",
    "E501": `ขออภัยท่านเคยลงทะเบียนเครื่องนี้กับ หมายเลขบัตรประชาชนอื่นไว้แล้ว กรุณาติดต่อเจ้าหน้าที่เพื่อตรวจสอบและแก้ไขข้อมูล โทร <a href="tel:#telephone_value#">#telephone_text#</a>`,
    "E502": "ลิงก์ของท่านหมดอายุการใช้งาน หากท่านประสงค์ลงทะเบียนใช้งาน",
    "E402": "ขออภัยในความไม่สะดวก เนื่องจากระบบตรวจสอบพบข้อมูลไม่ถูกต้อง ทำให้ไม่สามารถเพิ่มสิทธิ์การใช้งานให้กับท่านได้ กรุณาแจ้งแอดมินเพื่ออำนวยความสะดวกให้ท่านต่อไป",
    "E403": "ขออภัยในความไม่สะดวก เนื่องจากท่านเคยลงทะเบียนรับสิทธิ์ไปแล้ว สามารถตรวจสอบสิทธิ์และระยะเวลาใช้งานคงเหลือได้ที่เมนู \"พบหมอออนไลน์\" หากท่านไม่มีสิทธิ์คงเหลือ และสนใจใช้บริการ กรุณาแจ้งแอดมินเพื่ออำนวยความสะดวกให้ท่านต่อไป"
  }
  telephone_template = {
    'insure': {
      "text": "02 633 6060",
      "value": "026336060"
    },
    'mazda': {
      "text": "02 633 6066",
      "value": "026336066"
    },
    'ford': {
      "text": "02 633 6080",
      "value": "026336080"
    },
    'nissan': {
      "text": "02 633 6040",
      "value": "026336040"
    }
  }
  electronic_channel: number;
  ngOnInit() {
    const channel = this.lineStateAction.channelStateInfo;
    this.route.queryParams
      .subscribe(async (params) => {
        this.code = params.code;
        this.comcode = channel.comCode;
        this.electronic_channel = channel.electronic_channel
        if (params.code == "E501") {
          this.btnOk.set("โทร");
          this.isShowButton = true;
          const telephone_text = this.telephone_template[this.comcode].text;
          const telephone_value = this.telephone_template[this.comcode].value;
          this.body = this.error_template[this.code].replace('#telephone_text#', telephone_text).replace('#telephone_value#', telephone_value)
        }else {
          this.btnOk.set("คลิก");
          this.isShowButton = true;
          this.body = this.error_template[this.code]
        }
      });
  }

  onError() {

  }

  onOk() {
    const channel = this.lineActionService.channelStateInfo;
    if (this.code == "E501") {
      window.location.href = `tel:${this.telephone_template[this.comcode].value}`
    } else {
      const channel = this.lineActionService.channelStateInfo;
      window.location.href = 'https://line.me/R/oaMessage/' + channel.lineBotId
    }
  }

  onCancel() { }

  getPrimaryColor() {
    if (this.electronic_channel === 20) return 'rgb(130, 188, 0)'
  }

}
